import { useTheme } from '@material-ui/core';
import { Input, Switch } from '@room-match/shared-ui-components';
import { FormikProps, getIn } from 'formik';
import { useEffect, useState } from 'react';
import { ISocialMediaConstItem } from 'shared/constants/SOCIAL_MEDIA';
import { ITalentUpdatePayload } from 'shared/interfaces/ITalent';
import { getErrorMessage } from 'shared/utils/room-shared';
import { useDebouncedCallback } from 'use-debounce';
import { Container, CustomTextField, FlexMini, FlexRow, FollowerInput } from './SocialItem.styles';

type Props = {
  index: number;
  socialMedia: ISocialMediaConstItem;
  name: string;
  form: FormikProps<ITalentUpdatePayload>;
};

const addCommas = (value: any) => {
  if (!value) return value;
  const res = value.replace(/\b0|[a-z]|([1-9][0-9]*)\b/g, (match: any, capture: any) => {
    if (capture !== undefined) {
      return capture.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    } else {
      return '';
    }
  });
  return res;
};

const SocialItem: React.FC<Props> = ({ index, socialMedia, name, form }) => {
  const theme = useTheme();
  const debounced = useDebouncedCallback(() => form.handleSubmit(), 1500);
  const [followersInput, setFollowersInput] = useState<any>();

  const handleFollowerChange = (e: any) => {
    const { value } = e.target as { value: string };
    setFollowersInput(addCommas(value));
    form.setFieldValue(`social_media_accounts[${index}].followers`, value.replace(/\D/g, ''));
    debounced();
  };

  useEffect(() => {
    if (form.values.social_media_accounts) {
      setFollowersInput(addCommas(form.values.social_media_accounts[index].followers));
    }
  }, [form]);

  return (
    <div>
      {form.values.social_media_accounts && (
        <>
          <p style={{ color: theme.palette.type === 'dark' ? ' #c3ccd7' : '#484c52' }} color="lightGrey">
            {socialMedia.label}
          </p>
          <Container active={form.values.social_media_accounts[index].enabled}>
            <FlexMini>
              <FlexRow gap={2} minWidth={'50%'} style={{ marginRight: 10 }}>
                {socialMedia.icon}
                <span className="prefix">{socialMedia.prefix}</span>
                <CustomTextField
                  variant="standard"
                  disabled={!form.values.social_media_accounts[index].enabled}
                  placeholder={name}
                  name={`social_media_accounts[${index}].url`}
                  value={form.values.social_media_accounts[index].url}
                  onChange={(e) => {
                    const { value } = e.target as { value: string };
                    form.setFieldValue(`social_media_accounts[${index}].url`, value);
                    debounced();
                  }}
                  errorMessage={getErrorMessage(
                    getIn(form.touched, `social_media_accounts[${index}].url`),
                    getIn(form.errors, `social_media_accounts[${index}].url`),
                  )}
                  // InputProps={{
                  //   endAdornment: (
                  //     <InputAdornment position="end">
                  //       <EditIconTwoTone style={{ width: 13, margin: '0 0 0 10px' }} />
                  //     </InputAdornment>
                  //   ),
                  // }}
                />
              </FlexRow>

              {socialMedia.platform !== 'personal_website' && socialMedia.platform !== 'imdb' && (
                <FlexRow gap={5}>
                  Followers:
                  <FollowerInput
                    variant="standard"
                    placeholder={'Enter Number Here'}
                    disabled={
                      !(
                        form.values.social_media_accounts[index].enabled && form.values.social_media_accounts[index].url
                      )
                    }
                    value={followersInput}
                    onChange={(e) => {
                      handleFollowerChange(e);
                    }}
                    errorMessage={getErrorMessage(
                      getIn(form.touched, `social_media_accounts[${index}].followers`),
                      getIn(form.errors, `social_media_accounts[${index}].followers`),
                    )}
                    style={{ maxWidth: 130 }}
                    // InputProps={{
                    //   endAdornment: (
                    //     <InputAdornment position="end">
                    //       <EditIconTwoTone style={{ width: 13, margin: '0 0 0 10px' }} />
                    //     </InputAdornment>
                    //   ),
                    // }}
                  />
                  <Input
                    type="hidden"
                    style={{ display: 'none' }}
                    name={`social_media_accounts[${index}].followers`}
                    value={form.values.social_media_accounts[index].followers}
                  />
                </FlexRow>
              )}
            </FlexMini>

            <Switch
              checked={form.values.social_media_accounts[index].enabled}
              value={form.values.social_media_accounts[index].enabled}
              name={`social_media_accounts[${index}].enabled`}
              disabled={false}
              toggle={(e) => {
                form.setFieldValue(
                  `social_media_accounts[${index}].enabled`,
                  form.values.social_media_accounts ? !form.values.social_media_accounts[index].enabled : false,
                );
                form.handleSubmit();
              }}
            />
          </Container>
        </>
      )}
    </div>
  );
};

export default SocialItem;
